module.exports = __webpack_public_path__ + "img/20251104.8f304529.jpg";